"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _Icon = _interopRequireDefault(require("@mulesoft/anypoint-icons/lib/Icon"));
var _classnames = _interopRequireDefault(require("classnames"));
var _ListItem = _interopRequireDefault(require("../ListItem"));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var defaultProps = {
  theme: {},
  onKeyDown: function onKeyDown() {},
  onClick: function onClick() {}
};

/**
 * Provides decorated item for MenuItems list
 */
var MenuItem = exports["default"] = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(MenuItem, _React$Component);
  function MenuItem() {
    var _this;
    (0, _classCallCheck2["default"])(this, MenuItem);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, MenuItem, [].concat(args));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleClick", function (e) {
      var _this$props = _this.props,
        disabled = _this$props.disabled,
        onClick = _this$props.onClick;
      if (!disabled) {
        onClick(e);
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleKeyDown", function (e) {
      var _this$props2 = _this.props,
        disabled = _this$props2.disabled,
        onKeyDown = _this$props2.onKeyDown;
      if (!disabled) {
        onKeyDown(e);
      }
    });
    return _this;
  }
  (0, _createClass2["default"])(MenuItem, [{
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
        iconName = _this$props3.icon,
        isSelected = _this$props3.isSelected,
        className = _this$props3.className,
        disabled = _this$props3.disabled,
        children = _this$props3.children,
        theme = _this$props3.theme,
        href = _this$props3.href,
        target = _this$props3.target,
        testId = _this$props3.testId,
        getRef = _this$props3.getRef,
        tabIndex = _this$props3.tabIndex;
      var selectedClass = isSelected ? 'menu-is-selected' : '';
      var iconComponent = iconName ? /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
        className: theme.icon,
        name: iconName
      }) : undefined;
      var classes = (0, _classnames["default"])(className, /* user specified classNames */
      selectedClass, disabled && theme.disabled, theme.menuItem);
      return /*#__PURE__*/_react["default"].createElement(_ListItem["default"], {
        role: "menuitem",
        getRef: getRef,
        href: href,
        target: target,
        tabIndex: tabIndex,
        className: classes,
        icon: iconComponent,
        onClick: this.handleClick,
        onKeyDown: this.handleKeyDown,
        active: isSelected,
        testId: testId,
        "data-anypoint-component": MenuItem.displayName
      }, children);
    }
  }]);
  return MenuItem;
}(_react["default"].Component);
(0, _defineProperty2["default"])(MenuItem, "displayName", 'MenuItem');
(0, _defineProperty2["default"])(MenuItem, "defaultProps", defaultProps);
//# sourceMappingURL=MenuItem.js.map